import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { appRoutes } from '@/app/routes'
import { BRAND } from '@/config/brand.generated'
import { PUBLIC_PAGE_TITLES } from '@/lib/public-page-titles'

/** Bilinen sayfanın başlığı; uygulama sayfası "<Sayfa> — <Uygulama adı>", bilinmeyen yol yalnız uygulama adı. */
export function documentTitleFor(pathname: string): string {
  const publicTitle = PUBLIC_PAGE_TITLES[pathname]
  if (publicTitle) return publicTitle
  const match = appRoutes
    .filter((route) => !route.externalUrl && (pathname === route.path || pathname.startsWith(`${route.path}/`)))
    .sort((a, b) => b.path.length - a.path.length)[0]
  return match ? `${match.label} — ${BRAND.appName}` : BRAND.appName
}

const isKnown = (pathname: string) =>
  pathname in PUBLIC_PAGE_TITLES || pathname.startsWith('/app')

/**
 * #1421: sekme başlığı her rota değişiminde güncellenir (eskiden fiyat sayfasından kalan "Pricing — …" uygulamada da
 * görünüyordu). Sayfa ilk açılışta herkese açık/kabuk HTML'inin kendi başlığı zaten doğrudur; alias adresleri gibi
 * tabloda olmayan sayfalarda ilk açılışta ona dokunulmaz, sonraki gezinmelerde güncellenir.
 */
export function DocumentTitleObserver() {
  const { pathname } = useLocation()
  const firstRender = useRef(true)

  useEffect(() => {
    const first = firstRender.current
    firstRender.current = false
    if (first && !isKnown(pathname)) return
    document.title = documentTitleFor(pathname)
  }, [pathname])

  return null
}
